import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2693">
      <div className="dark" data-id="element-2694">
        <Hero data-id="element-2695" />
      </div>
      <WhyUs data-id="element-2696" />
      <ByTheNumbers data-id="element-2697" />
      <Services data-id="element-2698" />
      <HowItWorks data-id="element-2699" />
      <FAQ data-id="element-2700" />
      <Reviews data-id="element-2701" />
      <CtaBanner data-id="element-2702" />
    </main>;
}